import { Box, styled } from '@mui/material';

export const SaVoucherHeaderRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 36px;
`;

export const SaVoucherCompany = styled('p')`
  margin: 0;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--dk-text, #1d2025);
`;

/** 열이 많아 좁은 화면에선 표만 가로 스크롤 */
export const SaVoucherTableScroll = styled(Box)`
  overflow-x: auto;
  border-top: 1px solid var(--dk-line, #e7e9ec);
`;

export const SaVoucherTableRoot = styled('table')`
  width: 100%;
  min-width: 1280px;
  border-collapse: collapse;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  line-height: 20px;

  & th,
  & td {
    padding: 8px 12px;
    border-bottom: 1px solid var(--dk-line, #e7e9ec);
    vertical-align: middle;
    word-break: break-word;
  }

  & th {
    font-weight: 500;
    color: var(--dk-text-strong, #4d5157);
    background-color: var(--dk-bg-subtle, #f9fafb);
    text-align: center;
    white-space: nowrap;
  }

  & td {
    font-weight: 400;
    color: var(--dk-text, #1d2025);
    text-align: center;
  }

  & td[data-align='left'] {
    text-align: left;
  }

  & td[data-align='right'] {
    text-align: right;
    white-space: nowrap;
  }

  & tfoot th,
  & tfoot td {
    font-weight: 600;
    color: var(--dk-text, #1d2025);
  }

  & tfoot td {
    text-align: left;
  }
`;

export const SaVoucherLinkButton = styled('button')`
  display: inline-flex;
  padding: 4px;
  border: 0;
  background: none;
  color: var(--dk-text-strong, #4d5157);
  cursor: pointer;

  &:hover {
    color: var(--dk-accent, #0066cc);
  }
`;

/** 전표 행 아래 상세(G/L) 표를 담는 칸 — 바깥 표 패딩 없이 꽉 채움 */
export const SaVoucherDetailCell = styled('td')`
  && {
    padding: 0;
  }
`;

/** 상세(G/L) 표 — 레거시처럼 전표 행보다 한 톤 어두운 머리·옅은 바탕으로 구분 */
export const SaVoucherDetailTable = styled('table')`
  width: 100%;
  border-collapse: collapse;

  && th {
    background-color: var(--dk-bg-muted, #f3f5f6);
  }

  && td {
    background-color: var(--dk-bg-subtle, #f9fafb);
  }

  && tr:last-of-type td {
    border-bottom: 0;
  }
`;
